import { useRef } from 'react';
import AnimeCard from './AnimeCard';

export default function ScrollRow({ title, items = [], loading = false }) {
  const trackRef = useRef(null);

  if (!loading && items.length === 0) return null;

  const scroll = (dir) => {
    trackRef.current?.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  return (
    <section className="row">
      <div className="row__header">
        <h2 className="row__title">{title}</h2>
      </div>
      <div className="section-scroll-wrapper">
        <button className="scroll-btn left" onClick={() => scroll('left')} aria-label="Anterior">‹</button>
        <div className="row__track" ref={trackRef}>
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div
                  key={i}
                  className="acard"
                  style={{ background: 'var(--bg-card)', opacity: 0.5 }}
                >
                  <div style={{ aspectRatio: '2/3', background: 'var(--bg-elevated)' }} />
                  <div className="acard__meta">
                    <div style={{ height: 10, background: 'var(--bg-elevated)', borderRadius: 4, marginBottom: 6 }} />
                    <div style={{ height: 8, width: '60%', background: 'var(--bg-elevated)', borderRadius: 4 }} />
                  </div>
                </div>
              ))
            : items.map((anime) => <AnimeCard key={anime.id} anime={anime} />)}
        </div>
        <button className="scroll-btn right" onClick={() => scroll('right')} aria-label="Siguiente">›</button>
      </div>
    </section>
  );
}
